import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { GroupPolicyObjects } from 'src/app/core/models/config-entities';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { NodeService } from 'src/app/core/services/node.service';

@Component({
  selector: 'app-add-gpo',
  templateUrl: './add-gpo.component.html',
  styleUrls: ['./add-gpo.component.scss']
})
export class AddGpoComponent implements OnInit {
  @Output() gpoAdded = new EventEmitter<void>(); // Event emitter

  addGpoForm: UntypedFormGroup;
  fieldTextType: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<AddGpoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { gpoName: string },
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private configEntityService: ConfigEntityService,
  ) { }



  ngOnInit(): void {
    this.addGpoForm = new UntypedFormGroup({
      gpoName: new UntypedFormControl(
        '',
        Validators.required
      ),
      gpoDelegatedUsername: new UntypedFormControl(null, Validators.required),
      gpoDelegatedUserPassword: new UntypedFormControl(null, Validators.required),
    });
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  togglePassswordIcon() {
    this.fieldTextType = !this.fieldTextType
  }

  onSubmit(form){
    this.spinner.show("gpoList");
    if (form?.valid){
      let gpoToAdd: GroupPolicyObjects = {
        gpoName : form?.value?.gpoName,
        userId : form?.value?.gpoDelegatedUsername,
        password : form?.value?.gpoDelegatedUserPassword
      }
      this.configEntityService.addGroupPolicyObject(gpoToAdd)
      .subscribe({
        next: (data: any) => {
          this.snackBar.open(data?.message || "GPO added successfully.", "Ok", { duration: 3000 });
          this.gpoAdded.emit(); 
          this.dialogRef.close(true);
          this.spinner.hide("gpoList");
          if(data) {
            this.snackBar.open(data?.message, "Ok", { duration: 3000});
            this.dialogRef.close(false);
          }
          else{
            this.snackBar.open("Failed to add GPO.", "Ok", { duration: 3000});
            this.dialogRef.close(false);
          }
        },
        error: (err) => {
          this.spinner.hide("gpoList");
          this.snackBar.open(err?.message, "Ok", { duration: 3000});
          this.dialogRef.close(false);
        }
      })
    }
    else {
      this.snackBar.open("Please verify all entered details", "Ok", { duration: 3000 });
    }
  }
}
